import UserHistoryAction from "../UserHistoryAction/UserHistoryAction";

import styles from "./UserHistoryModalContent.module.css";

const UserHistoryModalContent = ({ userHistory }) => {
  return (
    <>
      {userHistory?.map((action, index) => (
        <div className={styles["history-item"]} key={index}>
          <UserHistoryAction action={action} />
        </div>
      ))}
      {userHistory?.length === 0 && (
        <p className={styles["empty-item"]}>Нет истории</p>
      )}
    </>
  );
};

export default UserHistoryModalContent;
